import ContactInt from "./ContactInt";

export const Contacts: ContactInt = {
  Blekendorf: {
    id: "Blekendorf".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Blekendorfer Totengilde von 1731",
    street: "Achtern Beeck 5",
    plz: "24327",
    town: "Blekendorf",
    location: "Gildehaus",
    telefon: "",
    email: "totengilde-blekendorf@outlook.de",
  },
    RathlauPokal: {
    id: "RathlauBlekendorf".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Totengilde Rathlau von 1729",
    street: "Achtern Beeck 5",
    plz: "24327",
    town: "Blekendorf",
    location: "Gildehaus der Blekendorfer Totengilde",
    telefon: "",
    email: "",
  },
    RathlauGildefest: {
    id: "RathlauGildefest".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Totengilde Rathlau von 1729",
    street: "Geschenberger Weg",
    plz: "24327",
    town: "Nessendorf",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Behrensdorf: {
    id: "Behrensdorf".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Behrensdorfer Totengilde von 1754",
    street: "Rabanser Weg (Sportplatz)",
    plz: "24321",
    town: "Behrensdorf",
    telefon: "",
    email: "info@behrensdorfer-totengilde.de",
    location: "Gildehaus",
  },
  Dannau: {
    id: "Dannau".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Totengilde Dannau und Umgebung von 1852",
    street: "Dorfstrasse 7",
    plz: "24329",
    town: "Dannau",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Darry: {
    id: "Darry".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Schieß- und Totengilde Darry von 1722",
    street: "Schulweg 9",
    plz: "24321",
    town: "Darry",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Hassberg: {
    id: "Hassberg".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Haßberger Totengilde von 1741",
    street: "Kiefernweg (hinter Nr 6 - Jägerhaus)",
    plz: "24321",
    town: "Hohwacht",
    location: "Schießstand",
    telefon: "",
    email: "",
  },
  Kakoehl: {
    id: "Kakoehl".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Kaköhler Totengilde von 1723",
    street: "Am Hopfenberg",
    plz: "24327",
    town: "Blekendorf/Kaköhl",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Neuhaus: {
    id: "Neuhaus".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Neuhauser Schützen- und Totengilde von 1881",
    street: "Seestrasse",
    plz: "24321",
    town: "Giekau",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Luetjenburg: {
    id: "Luetjenburg".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Lütjenburger Schützen-Totengilde von 1719",
    street: "Kieler Straße 34",
    plz: "24321",
    town: "Lütjenburg",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Matzwitz: {
    id: "Matzwitz".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Matzwitzer Schieß- und Totengilde",
    street: "Dorfstraße",
    plz: "24321",
    town: "Panker/Matzwitz",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Hoegsdorf: {
    id: "Hoegsdorf".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Högsdorfer Totengilde",
    street: "Blekendorfer Straße",
    plz: "24327",
    town: "Högsdorf",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Wangels: {
    id: "Wangels".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Schweinegilde Wangels von 1935 e.V.",
    street: "Im Hohen Redder",
    plz: "23758",
    town: "Grammdorf",
    location: "Sport-und Schützenklause (am Sportplatz)",
    telefon: "",
    email: "wangels@hotmail.com",
  },
  Wentorf: {
    id: "Wentorf".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Wentorfer Totengilde",
    street: "Schoolredder",
    plz: "24321",
    town: "Klamp/Wentorf",
    location: "Gildehaus",
    telefon: "",
    email: "",
  },
  Preetz: {
    id: "Preetz".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Preetzer Schützengilde von 1442 e. V.",
    street: "",
    plz: "24211",
    town: "Preetz",
    location: "Gildehaus",
    telefon: "",
    email: "1.aeltermann@preetzer-schuetzengilde.de",
  },
  DreiGildenBall: {
    id: "DreiGildenBall".concat((Math.random() + 1).toString(36).substring(7)),
    who: "Drei-Gilden-Ball",
    street: "Engelau 27",
    plz: "24321",
    town: "Giekau",
    location: "Engelauer Kamin",
    telefon: "+49 4381 905 050",
    email: "info@engelauer-kamin.de",
  },
};
